const SETTINGS = ['settings'];

export default SETTINGS;
